import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedPipesModule } from '@sd-portal/shared/pipes';
import { SharedUiModule } from '@sd-portal/shared/ui';
import { SharedUtilModule } from '../../../util/src/lib/sharedutil.module';

import { AppCancelComponent } from './components/app-cancel/app-cancel.component';
import { AppFormErrorSummarySheetComponent } from './components/app-form-error-summary-sheet/app-form-error-summary-sheet.component';
import { AppSaveComponent } from './components/app-save/app-save.component';
import { AppSearchComponent } from './components/app-search/app-search.component';
import { AppSearchFacade } from './components/app-search/app-search.facade';
import { SaveStateNotifierComponent } from './components/app-save/app-save-notifier';
import { AppSaveValidStatePipe } from './components/app-save/_pipes/app-save-valid-state.pipe';
import { AppUserInfoComponent } from './components/app-user-info/app-user-info.component';
import { AppUserInfoFacade } from './components/app-user-info/app-user-info.facade';
import { DialogUnauthSignoutComponent } from './auth/unauthorized/dialog-unauth-signout/dialog-unauth-signout.component';
import { DialogUnauthWarningComponent } from './auth/unauthorized/dialog-unauth-warning/dialog-unauth-warning.component';
import { ErrorSummaryItemComponent } from './components/app-form-error-summary-sheet/error-summary-item/error-summary-item.component';
import { ExceptionService } from './services/exception.service';
import { OidcCallbackComponent } from './auth/oidccallback/oidccallback.component';
import { PageErrorComponent } from './page-error/page-error.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { UnauthorizedComponent } from './auth/unauthorized/unauthorized.component';
import { AcknowledgementDialogComponent } from './components/acknowledgement/acknowledgement-dialog.component/acknowledgement-dialog.component';
import { AcknowledgementAlertComponent } from './components/acknowledgement/acknowledgement-alert.component/acknowledgement-alert.component';
import { AcknowledgementService } from './components/acknowledgement/acknowledgement.service';

@NgModule({
  imports: [CommonModule, RouterModule, SharedPipesModule, SharedUiModule, SharedUtilModule],
  exports: [
    AppCancelComponent,
    AppSaveComponent,
    AppSearchComponent,
    SaveStateNotifierComponent,
    AppUserInfoComponent,
    OidcCallbackComponent,
    UnauthorizedComponent,
    AcknowledgementDialogComponent,
    AcknowledgementAlertComponent
  ],
  declarations: [
    AppCancelComponent,
    AppFormErrorSummarySheetComponent,
    AppSaveComponent,
    AppSearchComponent,
    SaveStateNotifierComponent,
    AppSaveValidStatePipe,
    AppUserInfoComponent,
    DialogUnauthSignoutComponent,
    DialogUnauthWarningComponent,
    OidcCallbackComponent,
    PageErrorComponent,
    PageNotFoundComponent,
    UnauthorizedComponent,
    ErrorSummaryItemComponent,
    AcknowledgementDialogComponent,
    AcknowledgementAlertComponent
  ],
  providers: [ExceptionService, AppUserInfoFacade, AppSearchFacade, AcknowledgementService]
})
export class ShellModule {}
